import React, { useState, useContext, useEffect } from 'react'
import { FaSearch } from 'react-icons/fa'
import { AppRelevantDataContext } from '../../../AppContext';
import "../../CSS/GlobalSearchBox.css";
import { useDispatch, useSelector } from 'react-redux';
import { TbDeviceDesktop } from 'react-icons/tb';
import { FaInbox } from "react-icons/fa6";
import { appendGlobalSearchNode } from '../Store/Slices/deviceList';
import { addToOpenToiletNodes, setSearchedOrClickedToiletNode } from '../Store/Slices/treeAndSearchSlice';
import { setReRenderTreeUponSearch } from '../Store/Slices/deviceList';
import { IDS_DeviceID, IDS_DeviceName, IDS_Premises, IDS_NoMatchFound, IDS_PremisesLevels, IDS_Search, IDS_ClearSelection, IDS_AdvanceSearchFilter } from '../../../VcLanguage';
import { MdCancel } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { HiAdjustmentsHorizontal } from "react-icons/hi2";
import {appendAdvSearchList, clearAdvSearchList, updateAdvSearchFlag, updateIsAdvSearchedFilterDataEmpty} from '../Store/Slices/advanceSearchSlice';
import { useRef } from "react";

const VcSearchBox = () => {

  // Redux state selectors
  const deviceListRedux = useSelector((state) => state?.deviceList?.devices)
  const treeNodeListRedux = useSelector((state) => state?.treeNodeList?.nodeList)
  const advSearchListRedux = useSelector((state) => state?.advSearchList);

  // Hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Refs for click-outside handling
  const searchInputRef = useRef(null);
  const advBtnRef = useRef(null);
  const advPopupRef = useRef(null);

  // App context (language + callbacks)
  const context = useContext(AppRelevantDataContext)
  const t = context.t;

  // Final query string for advanced search (display purpose)
  const[finalQuery, setFinalQuery] = useState("");

  const [ state, setState ] = useState({
    devicesRedux: [],
    filteredList: [],
    showDropdown: false,
    treeNodesRedux: [],
    filteredToiletList: [],
    inputValue: '',
    showAdvancedFilterPopup: false
  })

  const [filters, setFilters] = useState({
    toiletName: "",
    deviceName: "",
    deviceId: "",
    hierarchyNode: "",
    online: false,
    offline: false 
  });

  // Sync redux data → local state & register click-outside listener
  useEffect(() => {
    // Update state when deviceListRedux changes
    if (deviceListRedux != null && deviceListRedux.length > 0) {
      setState(prevState => ({
        ...prevState,
        devicesRedux: deviceListRedux[0]
      }));
    }
  
    // Update state when treeNodeListRedux changes, only if it exists
    if (treeNodeListRedux != null && treeNodeListRedux.length > 0) {
      setState(prevState => ({
        ...prevState,
        treeNodesRedux: treeNodeListRedux[0]
      }));
    }

    // Update state when treeNodeListRedux changes, only if it exists
    if (advSearchListRedux != null && advSearchListRedux.length > 0) {
      setState(prevState => ({
        ...prevState,
        treeNodesRedux: treeNodeListRedux[0]
      }));
    }

    document.addEventListener('click', handleClickOutside);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [deviceListRedux, treeNodeListRedux, state.showDropdown, state.showAdvancedFilterPopup]);
  
  // Called when user cliks outside the dropdown <div/> block (Search Block)
  const handleClickOutside = (event) => {
    const viewportWidth = window.innerWidth;
    let dropdown = null;
    let searchInput = null;

    if(viewportWidth <= 550) {
      dropdown = document.querySelector('.mobileViewdropdown');
      searchInput = document.querySelector('.mobileViewSearchBoxInput');
    } else {
      dropdown = document.querySelector('.desktopViewDropdown');
      searchInput = document.querySelector('.searchBoxInput');
    }

    // if click is inside search input → ignore
    if (searchInputRef.current?.contains(event.target)) return;

    if (
      advPopupRef.current &&
      !advPopupRef.current.contains(event.target) &&
      advBtnRef.current &&
      !advBtnRef.current.contains(event.target)
    ) {
      setState(prevState => ({
        ...prevState,
        showAdvancedFilterPopup: false
      }));    
    }

    // Normal dropdown
    if (
      searchInputRef.current &&
      !searchInputRef.current.contains(event.target)
    ) {
      setState(prev => ({
        ...prev,
        showDropdown: false
      }));
    }
    
    if (dropdown && !dropdown.contains(event.target) && !searchInput.contains(event.target)) {
      setState(prevState => ({
        ...prevState,
        showDropdown: false,
        showAdvancedFilterPopup: false
      }));
    }
  };

  // On-Click Function for Input Text
  const selectedDeviceName = (e) => {
    const searchedInput = e.target.value.toLowerCase();

    // TURN OFF ADV SEARCH if input is manually cleared
    if (e.target.value.length === 0 && advSearchListRedux.advSearchFlag) {
      setFilters({ toiletName: "",
        deviceName: "",
        deviceId: "",
        hierarchyNode: "",
      });

      dispatch(updateAdvSearchFlag(false));
      dispatch(clearAdvSearchList());
      dispatch(updateIsAdvSearchedFilterDataEmpty(false));
    }

    const deviceIDs = [];
    state.devicesRedux?.map((device) => {
      const lowerCaseDeviceID = device.DeviceID.toLowerCase()
      const lowerCaseDeviceName = device.DeviceName.toLowerCase()

      if(lowerCaseDeviceID.includes(searchedInput) || lowerCaseDeviceName.includes(searchedInput)) {
        deviceIDs.push(device);
      }
    })

    const toiletNodeIDs = []
    state.treeNodesRedux?.map((toilet) => {
      const lowerCaseToiletID = toilet.id.toLowerCase();
      const lowerCaseToiletTitle = toilet.title.toLowerCase();

      if(lowerCaseToiletID.includes(searchedInput) || lowerCaseToiletTitle.includes(searchedInput)) {
        toiletNodeIDs.push(toilet)
      }
    })
    
    setState(prevState => ({
      ...prevState,
      filteredList: searchedInput.length <= 0 ? [] : deviceIDs,
      filteredToiletList: searchedInput.length <= 0 ? [] : toiletNodeIDs,
      inputValue: searchedInput
    }));
  }

  // To Render the list of Filtered Device ID(s) / Device Name(s) / Toilet-Node Name(s) in the Serach Bar at Every Matched-Input by the User
  const renderSelectedDeviceDashboard = (e) => {
    const deviceID = e.target.value;
    const matchedDevice = state.filteredList.find((devc) => devc == deviceID)
    if(matchedDevice) {
      context.onSelectedDevice(matchedDevice, matchedDevice, false, false, true, context.selectedNodeInfo.deviceType, context.selectedNodeInfo.parentID, context.selectedNodeInfo.SelectedNodeDeviceType, context.selectedNodeInfo.nodePath)      
    }
  }

  // Called when Clicked Device from the Search Dropdown
  const handleDeviceClick = (option) => {
    dispatch(setSearchedOrClickedToiletNode(''))
    dispatch(addToOpenToiletNodes(option.TreeParentID))
    dispatch(appendGlobalSearchNode(true))
    dispatch(setReRenderTreeUponSearch(Date.now())); // Sets the current time to re-render the tree upon search

    context.onSelectedDevice(option.DeviceID, option.DeviceName, false, false, true, context.selectedNodeInfo.deviceType, option.TreeParentID, option.SelectedNodeDeviceType, context.selectedNodeInfo.nodePath)      

    if(window.location.pathname == '/device/addNode') {
      navigate('/device/dashboard');
    }

    setState(prevState => ({
      ...prevState,
      showDropdown: false
    }))
  };

  // Called when Clicked Toilet from the Search Dropdown
  const handleNodeClick = (toiletNode) => {
    dispatch(setSearchedOrClickedToiletNode(toiletNode.id));
    dispatch(addToOpenToiletNodes(toiletNode.id));
    dispatch(appendGlobalSearchNode(true))
    dispatch(setReRenderTreeUponSearch(Date.now())); // Sets the current time to re-render the tree upon search
    
    context.onSelectedDevice(toiletNode.id, toiletNode.title, false, true, false, context.selectedNodeInfo.deviceType, context.selectedNodeInfo.parentID, context.selectedNodeInfo.SelectedNodeDeviceType, toiletNode.path)

    if(window.location.pathname == '/device/addNode') {
      navigate('/device/dashboard');
    }

    context.onSelectedNodeContainsChildNode(true)
    setState(prevState => ({
      ...prevState,
      showDropdown: false
    }))
  }

  // To Empty the Input Search by User
  const handleClearInput = () => {
    setState(prevState => ({
      ...prevState,
      showDropdown: false,
      inputValue: '',
      filteredList: [],
      filteredToiletList: []
    }));

    clearAll();
    dispatch(updateAdvSearchFlag(false));
    dispatch(updateIsAdvSearchedFilterDataEmpty(false));
    dispatch(clearAdvSearchList());
  };

  // Apply advanced search
  const applySearch = () => {
    let queryParts = [];

    if (filters.toiletName)
      queryParts.push(`Premises:(${filters.toiletName})`);

    if (filters.deviceName)
      queryParts.push(`Device:(${filters.deviceName})`);

    if (filters.deviceId)
      queryParts.push(`DeviceID:(${filters.deviceId})`);

    if (filters.hierarchyNode)
      queryParts.push(`PremiseLevels:(${filters.hierarchyNode})`);

    if (filters.online)
      queryParts.push(`Online:(${filters.online})`);

    if (filters.offline)
      queryParts.push(`Offline:(${filters.offline})`);

    const finalQuery = queryParts.join(" ");

    dispatch(appendAdvSearchList({
      toiletName: filters.toiletName,
      deviceName: filters.deviceName,
      deviceId: filters.deviceId,
      hierarchyNode: filters.hierarchyNode,
      online: filters.online,
      offline: filters.offline
    }));

    dispatch(updateAdvSearchFlag(true));

    setState(prevState => ({
      ...prevState,
      showAdvancedFilterPopup: false,
      showDropdown: false,
      inputValue: finalQuery
    }));
  };

  // Reset everything in advanced search filter popup
  const clearAll = () => {
    setFilters({ toiletName: "",
      deviceName: "",
      deviceId: "",
      hierarchyNode: "",
    });

    setState(prevState => ({
      ...prevState,
      inputValue: '',
      showAdvancedFilterPopup: !prevState.showAdvancedFilterPopup
    }));  

    dispatch(updateAdvSearchFlag(false));
    dispatch(updateIsAdvSearchedFilterDataEmpty(false));
    dispatch(clearAdvSearchList());    
  };

  // Check if all filters are empty
  const areAllFiltersEmpty = () => {
    return (
      !filters.toiletName &&
      !filters.deviceName &&
      !filters.deviceId &&
      !filters.hierarchyNode
    );
  };

  // On-Click function for Advanced Search Button
  const onAdvSearchClick = (e) => {
    e.stopPropagation(); 

    // Set adv search flag based on whether any filters are set
    if(areAllFiltersEmpty()){
      dispatch(updateAdvSearchFlag(false));
    } else {  
      dispatch(updateAdvSearchFlag(true));
    }

    setState(prevState => ({
      ...prevState,
      showAdvancedFilterPopup: !prevState.showAdvancedFilterPopup,
      showDropdown: false   // close normal search dropdown
    }))
  }


  let deviceWidth = window.innerWidth;
  
  return (
    <div 
      className='w-100 bg-white flex items-center'
      style={{ position: "relative", borderRadius: "0.4rem", backgroundColor: "pink" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "90%",
          backgroundColor: "#f1f3f4",   // change as you want
          padding: "0rem 0.5rem",
          borderRadius: "1.5rem",       // curved
        }}
      >
        {/* Search Icon */}
        <FaSearch className='animateScale' />

        {/* Input Box */}
        <input 
          onFocus={() => setState(prevState => ({
            ...prevState,
            showDropdown: true
          }))}
          placeholder={t(IDS_Search)}
          className={ deviceWidth <= 570 ? 'mobileViewSearchBoxInput' : 'searchBoxInput' }
          style={{
            borderRadius: "0.4rem",
            border: "none",
            outline: "none",
            background: "transparent",
            flex: 1  
          }}
          list="filteredList" 
          name="filteredList" 
          onInput={selectedDeviceName} 
          onChange={renderSelectedDeviceDashboard} 
          value={state.inputValue}
        />

        {/* Clear Button */}
        {state.inputValue.length > 0 && 
          <span style={{ cursor: "pointer", marginRight: "0.3rem" }} onClick={handleClearInput}>
            <MdCancel />
          </span>
        }

        {/* Advance Search Option Button */}
        <span 
          style={{ cursor: "pointer", fontSize: "1.5rem", fontWeight: 700, color: advSearchListRedux.advSearchFlag == true && !areAllFiltersEmpty() ? 'green' : 'black' }} 
          ref={advBtnRef}
          onClick={onAdvSearchClick}
          title={t(IDS_AdvanceSearchFilter)}
        >
          <HiAdjustmentsHorizontal/>          
        </span>        
      </div>

      {(state.showDropdown && state.inputValue.length > 0 && !advSearchListRedux.advSearchFlag) &&  (
        <div className={ deviceWidth <= 570 ? 'mobileViewdropdown' : 'desktopViewDropdown' } style={{ position: "absolute" }}>
          {
            ((state.filteredToiletList != null && state.filteredToiletList.length > 0) || 
            (state.filteredList != null && state.filteredList.length > 0)) ? (
              <>
                {/* RENDERING DEVICES  */}
                <div className='dropdown-title mx-1 px-2 pt-2 pb-1'>
                  <span style={{ textTransform: "uppercase" }}><b>{t(IDS_DeviceName)}</b></span>
                  <span style={{ textTransform: "uppercase" }}><b>{t(IDS_DeviceID)}</b></span>
                </div>
                <div style={{ overflowY: "scroll", maxHeight: "40vh" }}>
                  {state.filteredList?.map((filteredDevice, index) => (
                    <div
                      key={index}
                      className='dropdown-option'
                      id="filteredList"
                      onMouseDown={() => handleDeviceClick(filteredDevice)} // Use onMouseDown to prevent input blur
                    >
                      <span><FaInbox className='deviceIcon' /> {filteredDevice.DeviceName}</span>
                      <span>{filteredDevice.DeviceID}</span>
                    </div>
                  ))}
                </div>

                {/* RENDERING TOILETS  */}
                <div className='dropdown-title mx-1 px-2 pt-2 pb-1'>
                  <span style={{ textTransform: "uppercase" }}>
                    <b>{t(IDS_Premises)}</b>
                  </span>
                </div>
                <div style={{ overflowY: "scroll", maxHeight: "40vh" }}>
                  {state.filteredToiletList?.map((node) => {
                    return (
                      <div
                        className='dropdown-option'
                        id="filteredList"
                        onMouseDown={() => handleNodeClick(node)} // Use onMouseDown to prevent input blur
                      >
                        <span className='d-flex justify-content-center align-items-center'>
                          <TbDeviceDesktop className='toiletNodeIcon' /> {node.title}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </>
            ) : (
              <span style={{ fontSize: "11px", color: "#b2b2b2" }} className='mx-1 px-2 pt-2 pb-1'><b>{t(IDS_NoMatchFound)}</b></span>
            )
          }

          
        </div>
      )}

      {advSearchListRedux.advSearchFlag && advSearchListRedux.isAdvSearchedFilterDataEmpty == true && !areAllFiltersEmpty() && (
        <div className={ deviceWidth <= 570 ? 'mobileViewdropdown' : 'desktopViewDropdown' } style={{ position: "absolute" }}>
            <span style={{ fontSize: "11px", color: "#b2b2b2" }} className='mx-1 px-2 pt-2 pb-1'><b>{t(IDS_NoMatchFound)}</b></span>
        </div>
      )}

      {(state.showAdvancedFilterPopup) && (
        <div ref={advPopupRef} className={ deviceWidth <= 570 ? 'mobileViewdropdown' : 'desktopViewDropdown' } style={{ position: "absolute" }}>
          {
            state.showAdvancedFilterPopup && (
              <div className="adv-filter-container" ref={searchInputRef}>

                {/* Grid Body */}
                <div className="adv-filter-grid">
                  <div className="adv-field">
                    <label>{t(IDS_PremisesLevels)}</label>
                    <input
                      type="text"
                      value={filters.hierarchyNode}
                      onChange={(e) => setFilters({ ...filters, hierarchyNode: e.target.value })}
                      placeholder="Mumbai>South Zone"
                    />
                  </div>

                  <div className="adv-field">
                    <label>{t(IDS_Premises)}</label>
                    <input
                      type="text"
                      value={filters.toiletName}
                      onChange={(e) => setFilters({ ...filters, toiletName: e.target.value })}
                      placeholder="e.g. Public Toilet"
                    />
                  </div>

                  <div className="adv-field">
                    <label>{t(IDS_DeviceID)}</label>
                    <input
                      type="text"
                      value={filters.deviceId}
                      onChange={(e) => setFilters({ ...filters, deviceId: e.target.value })}
                      placeholder="e.g. B0E123E7789E8"
                    />
                  </div>

                  <div className="adv-field">
                    <label>{t(IDS_DeviceName)}</label>
                    <input
                      type="text"
                      value={filters.deviceName}
                      onChange={(e) => setFilters({ ...filters, deviceName: e.target.value })}
                      placeholder="e.g. Public Toilet Device"
                    />
                  </div>

                  {/* <div className="adv-status-row">
                    <label>
                      <input
                        type="checkbox"
                        checked={filters.online}
                        onChange={(e) =>
                          setFilters({ ...filters, online: e.target.checked })
                        }
                      />
                      Online Devices
                    </label>

                    <label>
                      <input
                        type="checkbox"
                        checked={filters.offline}
                        onChange={(e) =>
                          setFilters({ ...filters, offline: e.target.checked })
                        }
                      />
                      Offline Devices
                    </label>
                  </div> */}
                </div>

                {/* Footer */}
                <div className="adv-filter-footer">
                  <button className="btn clr-search-btn" onClick={clearAll}>
                    {t(IDS_ClearSelection)}
                  </button>
                  <button className="btn-sm adv-search-btn" onClick={applySearch}>
                    {t(IDS_Search)}
                  </button>
                </div>
              </div>
            )
          }
        </div>
      )}
    </div>
  )
}

export default VcSearchBox;